module.exports = "../images/families.jpg?v=6e335ef";